import React from "react";
import { Link } from "react-router-dom";
import "./MobileMenu.css";
import { FaTimes } from "react-icons/fa";

const MobileMenu = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="mobile-overlay" onClick={onClose}>
            <div className="mobile-drawer" onClick={(e) => e.stopPropagation()}>
                <div className="drawer-header">
                    <div className="drawer-logo">
                        <div className="logo-badge-sm">DG</div>
                        <span className="logo-text-sm">DATAGREFFE</span>
                    </div>
                    <button className="drawer-close" onClick={onClose}>
                        <FaTimes size={20} />
                    </button>
                </div>

                <nav className="drawer-nav">
                    <a href="https://datagreffe.ci" className="drawer-link" onClick={onClose}>
                        Entreprises
                    </a>
                    <a href="https://datagreffe.ci/formalite" className="drawer-link" onClick={onClose}>
                        Formalité
                    </a>
                    <a href="https://justice.datagreffe.ci" className="drawer-link" onClick={onClose}>
                        Justice
                    </a>
                    <Link to="/" className="drawer-link active" onClick={onClose}>
                        Textes de loi
                    </Link>
                </nav>

                <div className="drawer-divider"></div>

                <div className="drawer-contact">
                    <a href="mailto:contact@datagreffe.ci" className="drawer-contact-item">
                        contact@datagreffe.ci
                    </a>
                    <a href="tel:+2250718426314" className="drawer-contact-item">
                        07 18 42 63 14
                    </a>
                </div>

                <div className="drawer-divider"></div>

                <div className="drawer-actions">
                    <a href="https://datagreffe.ci/services" className="drawer-btn-services">
                        Nos Services
                    </a>
                    <a href="https://datagreffe.ci/dashboard" className="drawer-btn-connexion">
                        Connexion
                    </a>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu;